import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
import * as status from '../constants/imagePreloading';
var initialState = {
    isOpen: false,
    isThumbLoaded: {},
};
export default function isGridOpen(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    if (action.type === actionTypes.LOCATION_CHANGED) {
        var showGrid = action.showScreens;
        return updateIsOpen(state, showGrid);
    }
    if (action.type === actionTypes.SHOW_GRID) {
        return updateIsOpen(state, true);
    }
    if (action.type === actionTypes.HIDE_GRID) {
        return updateIsOpen(state, false);
    }
    if (action.type === actionTypes.SHOW_SCREEN) {
        return updateIsOpen(state, false);
    }
    if (action.type === actionTypes.IMAGE_THUMB_LOADED) {
        var id = action.id;
        return update(state, { isThumbLoaded: (_a = {}, _a[id] = { $set: status.DONE }, _a) });
    }
    if (action.type === actionTypes.IMAGE_THUMB_FAILED) {
        var id = action.id;
        return update(state, { isThumbLoaded: (_b = {}, _b[id] = { $set: status.ERROR }, _b) });
    }
    return state;
}
function updateIsOpen(state, isOpen) {
    return update(state, { isOpen: { $set: isOpen } });
}
